module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    style: (_vm.toptype == 1 ? '' : 'background-color: #3866bc;')
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "flex justify-center align-center img_all"
  }, [(_vm.toptype == 1) ? _c('el-image', {
    staticClass: "logo_img",
    attrs: {
      "src": require('../../static/assets/images/login/logo.png')
    }
  }) : _c('el-image', {
    staticClass: "logo_img",
    attrs: {
      "src": require('../../static/assets/images/logo/logo-white.png')
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('div', {
    staticClass: "response navall"
  }, [_c('div', {
    staticClass: "flex justify-center align-center marginauto navcon"
  }, [_vm._l((_vm.toplist), function(item, index) {
    return [(item.childs) ? [_c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "50px",
        "trigger": "hover"
      }
    }, [_vm._l((item.childs), function(eitem) {
      return _c('div', {
        staticClass: "tttta",
        on: {
          "click": function($event) {
            return _vm.changenav(eitem.path, index)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(eitem.title) + "\n\t\t\t\t\t\t\t\t")])
    }), _vm._v(" "), _c('div', {
      staticClass: "toponenew text-center pointer",
      class: _vm.toptype == item.type ? 'activenew' : '',
      style: (_vm.screenWidth < 1680 ? _vm.screenWidth < 1530 ? 'padding: 0 15px;font-size:15px' : 'padding: 0 30px;font-size:15px' : ''),
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('span', {
      style: (_vm.toptype == 1 ? 'color: #171717;' : '')
    }, [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])])], 2)] : _c('div', {
      staticClass: "toponenew text-center pointer",
      class: _vm.toptype == item.type ? 'activenew' : '',
      style: (_vm.screenWidth < 1680 ? _vm.screenWidth < 1530 ? 'padding: 0 15px;font-size:15px' : 'padding: 0 30px;font-size:15px' : ''),
      on: {
        "click": function($event) {
          return _vm.changenav(item.path, index)
        }
      }
    }, [_c('span', {
      style: (_vm.toptype == 1 ? 'color: #171717;' : '')
    }, [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])])]
  })], 2)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', [(!_vm.name) ? _c('div', {
    staticClass: "flex justify-center align-center"
  }, [_c('div', {
    staticClass: "login_text pointer",
    style: (_vm.toptype == 1 ? 'color: #0066d9;' : 'color: #fff;')
  }, [_c('a', {
    style: (_vm.toptype == 1 ? 'color: #0066d9;' : 'color: #fff;'),
    on: {
      "click": function($event) {
        return _vm.logchang(1)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" / "), _c('a', {
    style: (_vm.toptype == 1 ? 'color: #0066d9;' : 'color: #fff;'),
    on: {
      "click": function($event) {
        return _vm.logchang(2)
      }
    }
  }, [_vm._v("注册")])])]) : _vm._e(), _vm._v(" "), (_vm.name) ? _c('div', {
    staticClass: "flex justify-center align-center",
    staticStyle: {
      "margin-left": "10px",
      "height": "65px"
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('div', {
    staticClass: "header_rig_tt_let",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "cursor": "pointer"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "text-align": "center",
      "color": "#fff",
      "overflow": "hidden",
      "white-space": "nowrap",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down",
    staticStyle: {
      "font-size": "14px",
      "margin-top": "2px",
      "color": "#fff"
    }
  })])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "2"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "1"
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1) : _vm._e()])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a96dd202"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topnav.vue
// module id = 784
// module chunks = 20